/**
 *
 * IBM Confidential
 *
 * (C) Copyright IBM Corp. 2023, 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U. S. Copyright Office
 *
 * US Government Users Restricted Rights - Use, duplication or
 * disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 *
 **/
import _ from 'lodash';

import { ApiStatus } from '@ibm-watson/shared/ts';
import { IntegrationSchema } from '@ibm-watson/shared/ts/integration';
import { RootState } from '@ibm-watson/shared/ts/state';
import { selectAllIntegrations } from '../channels/selectors';

export const selectDraftServiceDesk = (
  state: RootState
): IntegrationSchema | null =>
  state.integrations?.serviceDesk?.draftServiceDesk?.integration;

export const isDraftServiceDeskSettingsDirty = (state: RootState): boolean =>
  state.integrations?.serviceDesk?.draftServiceDesk?.settings?.dirty ?? false;

export const isDraftServiceDeskSettingsValid = (state: RootState): boolean =>
  state.integrations?.serviceDesk?.draftServiceDesk?.settings?.valid ?? true;

export const isLoadServiceDeskLoading = (state: RootState): boolean =>
  state.integrations?.serviceDesk?.loadServiceDesk?.status ===
  ApiStatus.LOADING;

export const getConnectServiceDeskStatus = (state: RootState): ApiStatus =>
  state.integrations?.serviceDesk?.connectServiceDesk?.status;

export const selectIsServiceDeskDirty = (state: RootState): boolean =>
  state.integrations?.serviceDesk?.draftServiceDesk?.name?.dirty ||
  state.integrations?.serviceDesk?.draftServiceDesk?.settings?.dirty;

export const selectIsServiceDeskValid = (state: RootState): boolean =>
  state.integrations?.serviceDesk?.draftServiceDesk?.name?.valid &&
  state.integrations?.serviceDesk?.draftServiceDesk?.settings?.valid;

export const selectShouldSaveServiceDesk = (state: RootState): boolean =>
  !_.isNil(state.integrations?.serviceDesk?.draftServiceDesk?.integration) &&
  selectIsServiceDeskValid(state) &&
  selectIsServiceDeskDirty(state);

export const selectAllServiceDesksByType = (
  state: RootState,
  service_desk_type: string,
  assistant_id: string,
  environment_id: string
): IntegrationSchema[] => {
  const integrations = selectAllIntegrations(state);
  return integrations.filter(
    integration =>
      integration.environment_id === environment_id &&
      integration.assistant_id === assistant_id &&
      integration.type === service_desk_type
  );
};
